import { render } from "./ChatSidebar.vue?vue&type=template&id=3d2f46ed&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"

import "./ChatSidebar.vue?vue&type=style&index=0&id=3d2f46ed&scoped=true&lang=css"
import "./ChatSidebar.vue?vue&type=style&index=1&id=3d2f46ed&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2f46ed"]])

export default __exports__